import {
    DialogProvider,
    Dialog,
    DialogDismiss,
    DialogBody,
    DialogHeader,
    DialogHeading
} from '@/components/ui/dialog-atoms/DialogAtoms'
import {useTranslation} from '@/translations/i18n'
import {DialogStore} from '@ariakit/react'
import {FC} from 'react'
import {AddPatientAbsenceFields} from '../add-patient-absence-fields/AddPatientAbsenceFields'
import {AddPatientAbsenceDialogFooter} from '../add-patient-absence-dielog-footer/AddPatientAbsenceDialogFooter'
import {FormProvider, useForm} from 'react-hook-form'
import {zodResolver} from '@hookform/resolvers/zod'
import {AddPatientAbsenceFormValidationSchema} from '../../formSchemas'
import {PatientSmall} from '@/features/patients/types'

interface AddPatientAbsenceDialogProps {
    dialogStore: DialogStore
    selectedPatient?: Pick<PatientSmall, 'id' | 'fullName'> | null
}

export const AddPatientAbsenceDialog: FC<AddPatientAbsenceDialogProps> = ({dialogStore, selectedPatient}) => {
    return (
        <DialogProvider store={dialogStore}>
            <Dialog width="680px" overflowY="unset">
                <DialogContent dialogStore={dialogStore} selectedPatient={selectedPatient} />
            </Dialog>
        </DialogProvider>
    )
}

const DialogContent = ({selectedPatient}: AddPatientAbsenceDialogProps) => {
    const {t} = useTranslation()
    const form = useForm<AddPatientAbsenceFormValidationSchema>({
        resolver: zodResolver(AddPatientAbsenceFormValidationSchema),
        defaultValues: {
            patients: selectedPatient ? [selectedPatient] : [],
            communicatedOnTime: null
        }
    })

    return (
        <>
            <DialogHeader>
                <DialogHeading>{t('agenda:add_patient_absence')}</DialogHeading>
                <DialogDismiss />
            </DialogHeader>
            <FormProvider {...form}>
                <DialogBody>
                    <AddPatientAbsenceFields />
                </DialogBody>
                <AddPatientAbsenceDialogFooter />
            </FormProvider>
        </>
    )
}
